import { render } from "./B2bLoginPasswordFormVocento.vue?vue&type=template&id=946dd608&scoped=true&lang=pug"
import script from "./B2bLoginPasswordFormVocento.vue?vue&type=script&lang=js"
export * from "./B2bLoginPasswordFormVocento.vue?vue&type=script&lang=js"

import "./B2bLoginPasswordFormVocento.vue?vue&type=style&index=0&id=946dd608&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-946dd608"]])

export default __exports__